import React, { useMemo } from 'react';
import CampoComboPais from '../UI/campos/CampoComboPais.js';
import CampoEditableTexto from '../UI/campos/CampoEditableTexto.js';
import AgregarItemFiltro from '../UI/AgregarItemFiltro.js';
import * as Data from '../data/DataClubes.js';

const NuevoClubFiltro = (props) => {
  const autoAbrir = props.autoAbrir ?? false;

  // Configuración de campos
  const campos = useMemo(
    () => [
      {
        nombre: 'pais',
        titulo: 'País',
        componente: <CampoComboPais />,
        valorInicial: null,
      },
      {
        nombre: 'nombre',
        titulo: 'Nombre',
        componente: <CampoEditableTexto />,
        valorInicial: '',
      },
    ],
    []
  );

  // Validar filtros
  const validarFiltros = (filtros) => {
    if (!filtros.pais) {
      return {
        valido: false,
        error: 'Debe ingresar el país del nuevo club',
      };
    }
    if (!filtros.nombre || filtros.nombre.trim() === '') {
      return {
        valido: false,
        error: 'Debe ingresar el nombre del nuevo club',
      };
    }
    return { valido: true };
  };

  // Normalizar filtros
  const normalizarFiltros = (filtros) => {
    return {
      ...filtros,
      nombre: filtros.nombre.trim(),
    };
  };

  // Extraer nombre para búsqueda
  const extraerNombre = (filtros) => {
    return filtros.nombre || '';
  };

  // Buscar clubes existentes
  const onBuscar = async (filtros) => {
    return await Data.SearchClubes(filtros.pais, filtros.nombre);
  };

  // Crear nuevo club
  const onCrear = async (filtros) => {
    return await Data.PostNuevoClub(filtros.pais, filtros.nombre);
  };

  return (
    <AgregarItemFiltro
      objeto="club"
      campos={campos}
      onBuscar={onBuscar}
      onCrear={onCrear}
      onMostrarLista={props.onMostrarLista}
      validarFiltros={validarFiltros}
      normalizarFiltros={normalizarFiltros}
      extraerNombre={extraerNombre}
      autoAbrir={autoAbrir}
      ocultarBotonAgregar={autoAbrir}
      rutaDestino="/club/"
    />
  );
};

export default NuevoClubFiltro;
